import { render, staticRenderFns } from "./ApuracaoAcaoDetalhesProdutos.vue?vue&type=template&id=116c2fca"
import script from "./ApuracaoAcaoDetalhesProdutos.vue?vue&type=script&lang=js"
export * from "./ApuracaoAcaoDetalhesProdutos.vue?vue&type=script&lang=js"
import style0 from "./ApuracaoAcaoDetalhesProdutos.vue?vue&type=style&index=0&id=116c2fca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports